import { Cache, DataStore, DataStoreOptions } from '@skinsoft/data-store';
import { TranslatedString } from '@skinsoft/i18n';
import { Proxy } from '@skinsoft/network';
import { RecordMask } from './record-mask-data-store';

export class MetaRecordMaskDataStore extends DataStore<RecordMask> {

    public static getInstance() {
        if (!MetaRecordMaskDataStore.instance) {
            MetaRecordMaskDataStore.instance = new MetaRecordMaskDataStore();
        }

        return MetaRecordMaskDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$metaRecordMaskDataStore = MetaRecordMaskDataStore.getInstance();
    }

    private static instance: MetaRecordMaskDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<RecordMask>) {
        super(`/meta-record-masks`);
    }

    // @ts-ignore
    public searchAll(queryText: string, sortObject: any, pageSize: number) {
        throw new Error("This method is not implemented in this subclass")
    }
}